
import { defineComponent } from "vue";
import { loadSurveyResultsList } from "@/api/myprospects";

export default defineComponent({
  name: "myprospects",
  props: {
    widgetClasses: String,
  },
  data() {
    return {
      list: [] as any[],
      loading: true,
      cifid: 0,
      shareLink: "",
      copiedKey: false,
      sharing: {
        title: "Orbix Victus Survey",
        description: "Let us know you more by answering this survey!",
        quote: "",
        hashtags: "digitalprotect;accidentcoverage;familyprotection;",
        twitterUser: "youyuxi",
      },
      networks: [
        { network: "email", name: "Email", icon: "far fa-envelope", color: "#333333" },
        { network: "facebook", name: "Facebook", icon: "fab fa-facebook-f", color: "#1877f2" },
        { network: "linkedin", name: "LinkedIn", icon: "fab fa-linkedin", color: "#007bb5" },
        { network: "messenger", name: "Messenger", icon: "fab fa-facebook-messenger", color: "#0084ff" },
        { network: "skype", name: "Skype", icon: "fab fa-skype", color: "#00aff0" },
        { network: "sms", name: "SMS", icon: "far fa-comment-dots", color: "#333333" },
        { network: "telegram", name: "Telegram", icon: "fab fa-telegram-plane", color: "#0088cc" },
        { network: "twitter", name: "Twitter", icon: "fab fa-twitter", color: "#1da1f2" },
        { network: "viber", name: "Viber", icon: "fab fa-viber", color: "#59267c" },
        { network: "whatsapp", name: "WhatsApp", icon: "fab fa-whatsapp", color: "#25d366" },
      ],
      share_socmed: "",
      showShareDiv: false,
    };
  },
  methods: {
    async loadSurveyResultsList() {
      this.loading = true;
      const response = await loadSurveyResultsList();
      this.list = response.data.pageList;
      this.cifid = response.data.cifid;
      this.shareLink = "https://survey.orbixvictusinternational.com/?cifid=" + this.cifid;
      this.loading = false;
    },

    toggleSharePanel() {
      this.showShareDiv = !this.showShareDiv;
    },

    async copyLink(url: string) {
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(url);
        } else {
          const input = document.createElement("input");
          input.value = url;
          document.body.appendChild(input);
          input.select();
          document.execCommand("copy");
          document.body.removeChild(input);
        }
        this.copiedKey = true;
        setTimeout(() => {
          this.copiedKey = false;
        }, 2000);
      } catch (e) {
        console.error(e);
      }
    },
  },
  mounted() {
    this.loadSurveyResultsList();
  },
});
